<template>
  <v-row no-gutters class="kpi-bar px-3 pb-2">
    <v-col cols="12" sm="6" md="3" class="kpi">
      <div class="kpi-label"><v-icon small class="mr-1">dns</v-icon>Saldo Syscore al {{ shortDate }}</div>
      <div class="kpi-value">{{ formatUtils.formatMoney(summary.saldo_final_syscore) }}</div>
      <div class="kpi-sub">Saldo inicial {{ formatUtils.formatMoney(summary.saldo_inicial_syscore) }}</div>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="kpi">
      <div class="kpi-label"><v-icon small class="mr-1">account_balance</v-icon>Saldo banco al {{ shortDate }}</div>
      <div class="kpi-value">{{ formatUtils.formatMoney(summary.saldo_final_banco) }}</div>
      <div class="kpi-sub">Saldo inicial {{ formatUtils.formatMoney(summary.saldo_inicial_banco) }}</div>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="kpi">
      <div class="kpi-label"><v-icon small class="mr-1">difference</v-icon>Diferencia sin explicar</div>
      <div class="kpi-value" :class="Math.abs(summary.resumen.diferencia) >= 0.01 ? 'error--text' : 'success--text'">
        {{ formatUtils.formatMoney(summary.resumen.diferencia) }}
      </div>
      <div class="kpi-sub">Diferencia de saldos (Banco − Syscore): {{ formatUtils.formatMoney(summary.diferencia_saldos) }}</div>
      <div v-if="fromOpening" class="kpi-sub warning--text">
        <v-icon x-small color="warning">warning</v-icon> Viene del saldo inicial: no coinciden al comenzar el período
      </div>
    </v-col>
    <v-col cols="12" sm="6" md="3" class="kpi">
      <div class="kpi-label"><v-icon small class="mr-1">donut_large</v-icon>Pendientes</div>
      <div class="kpi-value">{{ summary.counts.pending_banco }} · {{ summary.counts.pending_syscore }}</div>
      <div class="kpi-sub">banco · Syscore</div>
      <v-progress-linear :value="progress" color="success" height="6" rounded class="mt-2"></v-progress-linear>
      <div class="kpi-sub">{{ summary.progress.conciliados }} de {{ summary.progress.total }} conciliados</div>
    </v-col>
  </v-row>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  props: {
    summary: Object,
    dateTo: String,
  },
  data() {
    return { formatUtils };
  },
  computed: {
    shortDate() {
      return this.dateTo ? formatUtils.formatDateString(this.dateTo).substr(0, 5) : "";
    },
    // La diferencia sin explicar es la que ya traían los saldos iniciales
    fromOpening() {
      const s = this.summary;
      const opening = Math.round((s.saldo_inicial_banco - s.saldo_inicial_syscore) * 100) / 100;
      return Math.abs(s.resumen.diferencia) >= 0.01 && Math.abs(s.resumen.diferencia - opening) < 0.01;
    },
    progress() {
      const p = this.summary.progress;
      return p.total ? (p.conciliados * 100) / p.total : 0;
    },
  },
};
</script>

<style scoped>
/* !important: no-gutters de Vuetify anula el padding de las columnas */
.kpi {
  padding: 14px 24px !important;
  border-right: 1px solid #eee;
}
.kpi:last-child {
  border-right: none;
}
.kpi-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #616161;
}
.kpi-value {
  font-size: 20px;
  font-weight: 500;
  margin-top: 4px;
}
.kpi-sub {
  font-size: 13px;
  color: #757575;
}
</style>
